import { DataResponseRole, Permission, PermissionCreateRequest, PermissionsSearchRequest, PermissionUpdateRequest, Role, RoleCreateRequest, RolesSearchRequest, RoleUpdateRequest, User } from "@bluefalcon/users-management-client-fetch";
import { falconClients } from "../clients/falcon.client";

export class IAMService {

    async searchRoles(request: RolesSearchRequest): Promise<DataResponseRole> {
        const roles = await falconClients.iam.searchRoles({
            rolesSearchRequest: request,
        });
        return roles;
    }

    async searchPermissions(request: PermissionsSearchRequest): Promise<Permission[]> {
        const permissions = await falconClients.iam.searchPermissions({
            permissionsSearchRequest: request,
        });
        return permissions.results;
    }

    async createRole(request: RoleCreateRequest): Promise<Role> {
        return falconClients.iam.createRole({
            roleCreateRequest: request,
        });
    }

    async createPermission(request: PermissionCreateRequest): Promise<Permission> {
        return falconClients.iam.createPermission({
            permissionCreateRequest: request,
        });
    }

    async updatePermissionById(id: number, data: PermissionUpdateRequest): Promise<Permission> {
        return falconClients.iam.updatePermissionById({
            id,
            permissionUpdateRequest: data,
        });
    }

    async addRoleToUser(userId: string, roleId: number): Promise<User> {
        return falconClients.admin.updateUserByIdAdmin({
            id: userId,
            userUpdateRequest: {
                role: { add: [roleId] },
            },
        });
    }

    async updateRoleById(id: number, data: RoleUpdateRequest): Promise<Role> {
        return falconClients.iam.updateRoleById({
            id,
            roleUpdateRequest: data,
        });
    }

    async addPermissionToRole(permissionId: number, roleId: number): Promise<Role> {
        return falconClients.iam.updateRoleById({
            id: roleId,
            roleUpdateRequest: {
                permissions: {
                    add: [permissionId],
                    remove: [],
                },
            },
        });
    }

    async removeRoleFromUser(userId: string, roleId: number): Promise<User> {
        return falconClients.admin.updateUserByIdAdmin({
            id: userId,
            userUpdateRequest: {
                role: { remove: [roleId] },
            },
        });
    }

    async removePermissionFromRole(permissionId: number, roleId: number): Promise<Role> {
        return falconClients.iam.updateRoleById({
            id: roleId,
            roleUpdateRequest: {
                permissions: {
                    add: [],
                    remove: [permissionId],
                },
            },
        });
    }
}
